import React from "react";
import { Chart } from "primereact/chart";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { ComposedChart, XAxis, YAxis, Line, Bar, PieChart, Pie, Tooltip, Cell, Legend, ResponsiveContainer, LineChart, CartesianGrid } from 'recharts';
const CustomerOverview = ({ 
    customer,
    handleCreateInvoice,
    handleCreatePrescription ,
    handleUpdateCustomer,
    invoicePieData,
    paymentBarData,
    paymentData,
    visible,
    onHide,
    relatives,
    handleRelativeClick,
    handleAddRelative,
    initCust,
    getColorForStatus,
    stats,
    portalLink,
    handleGrantHistory,
}) => {
    const navigate = useNavigate();
    return (
                    <div className="p-col-12 p-md-4">
                        {customer ? (
                            <Card
                            header={
                                    <div className="flex justify-content-between align-items-center gap-4 md:gap-2">
                                        <div className="flex flex-wrap align-items-center gap-4 sm:gap-2">
                                        <span style={{paddingLeft:'25px', paddingTop:'25px'}}><h5><b>{`Details of ${customer.title} ${customer.first_name} ${customer.last_name}`}</b></h5></span>
                                        {customer.relative_flg === true? (
                                            <i title="Display Relatives" onClick={handleRelativeClick} className="pi pi-users" style={{ fontSize: '1.5rem', color: '#4CAF50', paddingLeft:'20px', paddingTop:'10px', cursor:'pointer' }}></i>
                                        ):(<p></p>)}
                                        </div>
                                        <div className="flex flex-wrap align-items-center gap-2 sm:gap-2">
                                        <Button label="Create Invoice" icon="pi pi-calculator" className="p-button-success" onClick={handleCreateInvoice} style={{borderRadius:"6px"}}/>
                                        <Button label="Create Prescription" icon="pi pi-clipboard" className="p-button-primary" onClick={handleCreatePrescription} style={{borderRadius:"6px"}}/>
                                        <Button label="Update Customer" icon="pi pi-user-edit" className="p-button-warning" onClick={handleUpdateCustomer} style={{borderRadius:"6px"}}/>
                                        <Button label="Create Relative" icon="pi pi-users" className="p-button-help" onClick={handleAddRelative} style={{borderRadius:"6px"}}/>
                                        </div>
                                    </div>
                                }
                            >
        
                                <div className="lg:flex justify-content-between align-items-center gap-4">
                                    {/* Customer Photo Placeholder */}
                                    <div className="flex-shrink-0" style={{marginRight:'50px', marginLeft:'25px'}}>
                                        <div className="w-8rem h-8rem bg-gray-300 flex align-items-center justify-content-center" >
                                            <i className="pi pi-user" style={{ fontSize: '3rem', color: '#6c757d' }}></i>
                                        </div>
                                    </div>
        
                                    {/* Customer Information */}
                                    <div className="flex-grow-1 mx-4">
                                        <p><strong>Phone: </strong> {customer.phone_number}</p>
                                        <p><strong>Email: </strong> {customer.email}</p>
                                        <p><strong>Address: </strong> {customer.address}</p>
                                        <p><strong>NIC: </strong> {customer.nic}</p>
                                        <p><strong>Passport: </strong> {customer.passport}</p>
                                    </div>
                                    <div className="flex-grow-1 mx-4">
                                        <p><strong>Date Of Birth: </strong> {customer.dob ? new Date(customer.dob).toLocaleDateString() : ''}</p>
                                        <p><strong>Category: </strong> {customer.category}</p>
                                        <p><strong>Segment: </strong> {customer.segment}</p>
                                        <p><strong>Priority: </strong> {customer.priority}</p>
                                        <p><strong>Status: </strong><Tag value={customer.status} severity={customer.status === 'Blacklisted'?'danger': customer.status === 'Regular'?'success':'info'} /></p>
                                    </div>
                                    <div className="flex-grow-1 mx-4">
                                        <p><strong>Created On: </strong> {new Date(customer.created_at).toLocaleString()}</p>
                                        <p><strong>Updated On: </strong> {new Date(customer.updated_at).toLocaleString()}</p>
                                        {/* ── FitMe Portal Status ───────────────────────────────────── */}
                                        <div style={{
                                            marginTop: 16,
                                            padding: "12px 18px",
                                            background: portalLink ? "#f0fdf4" : "#f8fafc",
                                            border: `1px solid ${portalLink ? "#86efac" : "#e2e8f0"}`,
                                            borderRadius: 10,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            gap: 10,
                                        }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                <i
                                                    className={`pi ${portalLink ? "pi-check-circle" : "pi-times-circle"}`}
                                                    style={{ fontSize: 20, color: portalLink ? "#16a34a" : "#94a3b8" }}
                                                />
                                                <div>
                                                    <div style={{ fontWeight: 600, fontSize: 13.5 }}>
                                                        FitMe Portal
                                                    </div>
                                                    {portalLink ? (
                                                        <div style={{ fontSize: 12, color: "#475569", marginTop: 2 }}>
                                                            Linked since {new Date(portalLink.linked_at).toLocaleDateString()}
                                                            {" · "}
                                                            <span style={{
                                                                fontWeight: 600,
                                                                color: portalLink.history_access === "full" ? "#16a34a" : "#d97706",
                                                            }}>
                                                                {portalLink.history_access === "full"
                                                                    ? "Full history access"
                                                                    : portalLink.history_access === "future_only"
                                                                    ? "Future records only"
                                                                    : "No access"}
                                                            </span>
                                                            {portalLink.history_access === "full" && portalLink.history_granted_at && (
                                                                <span style={{ fontWeight: 400, color: "#64748b" }}>
                                                                    {" · Granted "}{new Date(portalLink.history_granted_at).toLocaleDateString()}
                                                                    {portalLink.history_granted_by && ` by ${portalLink.history_granted_by}`}
                                                                </span>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 2 }}>
                                                            Customer has not linked a portal account
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {portalLink && portalLink.history_access !== "full" && (
                                                <Button
                                                    label="Grant History Access"
                                                    icon="pi pi-history"
                                                    className="p-button-sm p-button-outlined p-button-success"
                                                    onClick={handleGrantHistory}
                                                    style={{ borderRadius: 8, fontSize: 12.5 }}
                                                    tooltip="Allow this customer to view their full prescription and invoice history in FitMe"
                                                    tooltipOptions={{ position: "left" }}
                                                />
                                            )}

                                            {portalLink && portalLink.history_access === "full" && (
                                                <span style={{
                                                    fontSize: 12, fontWeight: 600, color: "#16a34a",
                                                    display: "flex", alignItems: "center", gap: 5,
                                                }}>
                                                    <i className="pi pi-lock-open" style={{ fontSize: 12 }} />
                                                    Full access granted
                                                </span>
                                            )}
                                        </div>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p>
                                    </div>
        
                                    {/* Buttons (Stacked Vertically) */}
                                    <div className="flex flex-column gap-2">
                                        
                                    </div>
                                </div>
                            </Card>
                        ) : (
                            <p>Loading customer details...</p>
                        )}
                        {customer && stats ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" style={{marginTop:'20px'}}>
                        <Card title="Invoice Status" className="p-4 shadow-lg">
                            {invoicePieData.length > 0 ? (
                                <ResponsiveContainer width={300} height={300}>
                                <PieChart margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
                                    <Pie
                                    dataKey="value"
                                    data={invoicePieData}
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={100}
                                    label
                                    >
                                    {invoicePieData.map((entry, index) => (
                                        <Cell
                                        key={`cell-${entry.rawStatus}-${index}`}
                                        fill={getColorForStatus(entry.rawStatus, index)}
                                        />
                                    ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend verticalAlign="bottom" height={36} />
                                </PieChart>
                                </ResponsiveContainer>
                            ) : (
                                <div className="text-sm text-gray-500">
                                No invoice data for the selected period.
                                </div>
                            )}
                        </Card>
                        {/* Payments Bar Chart */}
                        <Card title="Payment Summary" className="p-4 shadow-lg">
                        <ResponsiveContainer width={300} height={300}>
                            <ComposedChart
                                data={paymentBarData}
                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            >
                                <XAxis dataKey="name" />
                                <YAxis yAxisId="left" label={{ value: 'Amount (LKR)', angle: -90, position: 'insideLeft' }} />
                                <YAxis yAxisId="right" orientation="right" label={{ value: 'Count', angle: -90, position: 'insideRight' }} />
                                
                                <Tooltip />
                                <Legend />
                                
                                {/* Payment Amount (Bar) */}
                                <Bar yAxisId="left" dataKey="amount" fill="#8884d8" name="Payment Amount (LKR)" />
                                
                                {/* Payment Count (Line) */}
                                <Line 
                                yAxisId="right" 
                                type="monotone" 
                                dataKey="count" 
                                stroke="#82ca9d" 
                                strokeWidth={2} 
                                dot={{ r: 4 }}
                                name="Payment Count"
                                />
                            </ComposedChart>
                        </ResponsiveContainer>
                        </Card>
                        {/* Payment Trend Chart */}
                        <Card title="Payment Trend" className="p-4 shadow-lg">
                        <ResponsiveContainer width={300} height={300}>
                        {paymentData && paymentData.length > 0 ? (
                            <LineChart data={paymentData} margin={{ top: 10, right: 30, left: 0, bottom: 10 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip />
                                <Line type="monotone" dataKey="total_amount" stroke="#8884d8" strokeWidth={2} />
                            </LineChart>
                        ) : (
                            <p>No payment data available</p>
                        )}
                        </ResponsiveContainer>
                        </Card>
                      </div>
                      ) : (
                        <p>Loading charts...</p>
                      )
                        }
                        <Dialog
                            header={
                                <span>
                                    Relatives of{" "}                                  
                                    <a
                                        href={`/customers/${initCust.id}`}
                                        style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            navigate(`/customers/${initCust.id}`);
                                        }}
                                    >
                                        {initCust.title} {initCust.first_name} {initCust.last_name}
                                    </a>
                                </span>
                            }
                            visible={visible}
                            style={{ width: '50vw' }}
                            onHide={onHide}
                            dismissableMask
                        >
                            <DataTable value={relatives}>
                                <Column field="first_name" header="First Name" />
                                <Column 
                                    field="last_name" 
                                    header="Last Name" 
                                    body={(rowData) => (
                                        <a
                                            href={`/customers/${rowData.id}`} 
                                            style={{ textDecoration: 'none', color: 'blue', cursor: 'pointer' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(`/customers/${rowData.id}`);
                                            }}
                                        >
                                            {rowData.last_name}
                                        </a>
                                    )} 
                                />
                                <Column field="phone_number" header="Phone Number" />
                                <Column field="relationship" header="Relationship" />
                            </DataTable>
                        </Dialog>
                    </div>
        
    );
};

export default CustomerOverview;